module.exports = __webpack_public_path__ + "static/media/yellow.67d9b05d.svg";